import { render, staticRenderFns } from "./DzjgmQuery.vue?vue&type=template&id=7c6956ce&"
import script from "./DzjgmQuery.vue?vue&type=script&lang=js&"
export * from "./DzjgmQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports